import store from 'Store';
import { hasInMeta } from 'Utils/router';

export async function resolveGeneral(to, from) {
  const promises = [];
  let userData = null;
  // If there is no from route, means it's initial loading
  if (!from.name) {
    // init auth
    const res = await store.dispatch('login/initAuth') || {};
    userData = res?.userData; // eslint-disable-line
  } else {
    // Otherwise check token if it needed to refresh
    await store.dispatch('login/checkToken');
  }
  if (store.getters['login/isLoggedIn']) {
    const profileDataPromise = store.dispatch(
      'profile/getProfileData',
      { updateEmptyFieldsData: userData },
    );
    if (hasInMeta(to, 'requiresProfileData')) {
      promises.push(profileDataPromise);
    }
  }
  return promises;
}
